
import { createSlice } from "@reduxjs/toolkit";
const departmentsSlice = createSlice({
    name: "department",
    initialState: {
        creatdepartment: {
            isFetching: false,
            error: false,
            success: false
        },
        editdepartment: {
            isFetching: false,
            error: false,
            success: false
        },
        departments: {
            listdepartments: null,
            isFetching: false,
            error: false,
        }
        
    },
    reducers: {
        editDepartmentStart: (state) => {
            state.editdepartment.isFetching = true;
        },
        editDepartmentSuccess: (state) => {
            state.editdepartment.isFetching = false;
            state.editdepartment.error = false;
            state.editdepartment.success = true;
        },
        editDepartmentFailed: (state) => {
            state.editdepartment.isFetching = false;
            state.editdepartment.error = true;
            state.editdepartment.success = false;
        },
        createDepartmentStart: (state) => {
            state.creatdepartment.isFetching = true;
        },
        createDepartmentSuccess: (state) => {
            state.creatdepartment.isFetching = false;
            state.creatdepartment.error = false;
            state.creatdepartment.success = true;
        },
        createDepartmentFailed: (state) => {
            state.creatdepartment.isFetching = false;
            state.creatdepartment.error = true;
            state.creatdepartment.success = false;
        },
        getDepartmentStart: (state) => {
            state.departments.isFetching = true;
        },
        getDepartmentSuccess: (state, action) => {
            state.departments.isFetching = false;
            state.departments.listdepartments = action.payload;
            state.departments.error = false;
        },
        getDepartmentFailed: (state) => {
            state.departments.isFetching = false;
            state.departments.error = true;
        },
        
    }
});
export const {
    editDepartmentStart,
    editDepartmentSuccess,
    editDepartmentFailed,
    createDepartmentStart,
    createDepartmentSuccess,
    createDepartmentFailed,
    getDepartmentStart,
    getDepartmentSuccess,
    getDepartmentFailed
} = departmentsSlice.actions;
export default departmentsSlice.reducer;
